import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';

/**
 * MaintenanceBanner - Shows a maintenance notice to users
 * 
 * This banner:
 * - Does NOT block the site (Google can still crawl)
 * - Does NOT add any meta tags that would hurt SEO
 * - Is dismissible by users
 * - Shows a friendly message
 * - Fixed position at top, above navbar
 */
const MaintenanceBanner = ({ enabled = true }) => {
  const [dismissed, setDismissed] = useState(false);
  
  // Don't render if disabled or dismissed
  if (!enabled || dismissed) {
    return null;
  }
  
  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-amber-600 to-orange-600 text-white py-2 px-4 z-[9999] shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 flex-shrink-0 animate-pulse" />
          <p className="text-sm md:text-base font-medium">
            <span className="font-bold">🛠️ Maintenance in Progress</span>
            <span className="hidden sm:inline"> — We're improving our services. Some features may be temporarily unavailable.</span>
            <span className="sm:hidden"> — Some features may be unavailable.</span>
          </p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 hover:bg-white/20 rounded-full transition-colors flex-shrink-0"
          aria-label="Dismiss maintenance notice"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
